import { CSSObject, styled } from 'libs/ui/styled';

export const UnorderedListStyled = styled('ul')(
  () =>
    ({
      paddingInlineStart: '40px',
    } as CSSObject)
);
